import { getDisplayNameWithCount } from '@/bundles/GroupFilters/helpers/formatters/names/getDisplayNameWithCount';
import { IFilterSelectedBroker } from '@/bundles/GroupFilters/interfaces/inputs/IFilterSelectedBroker';

export const getBrokersSelectFormattedValue = (value: IFilterSelectedBroker[]) => {
  return getDisplayNameWithCount(value, 'broker')
}
